export type AgreementState = {
  policy: boolean;
};

export const agreementInitialState: AgreementState = {
  policy: false,
};
